import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import color from "../../constants/color";
import styles from "./style";

const getStatusConfig = (status) => {
  const isError = status === "error";

  return {
    title: isError ? "Payment Failed" : "Payment Successful",
    message: isError
      ? "We could not complete the payment. Please try again."
      : "Your payment has been processed successfully.",
    icon: isError ? (
      <ErrorOutlineIcon sx={{ fontSize: "30px", color: color.red }} />
    ) : (
      <CheckCircleOutlineIcon sx={{ fontSize: "30px", color: color.primary }} />
    ),
    iconBackground: isError ? color.lightRed : color.lightGreen,
    buttonBackground: isError ? color.red : color.primary,
  };
};

const PaymentStatusModal = ({
  open = false,
  status = "success",
  title = "",
  message = "",
  reference = "",
  onClose = () => {},
}) => {
  const normalizedStatus = status === "error" ? "error" : "success";
  const statusConfig = getStatusConfig(normalizedStatus);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="payment-status-title"
      sx={styles.dialogSx}
    >
      <DialogContent sx={styles.container}>
        <IconButton
          aria-label="close payment status modal"
          onClick={onClose}
          sx={styles.closeButton}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            ...styles.iconWrapper,
            backgroundColor: statusConfig.iconBackground,
          }}
        >
          {statusConfig.icon}
        </Box>

        <Typography id="payment-status-title" sx={styles.title}>
          {title || statusConfig.title}
        </Typography>

        <Typography sx={styles.message}>
          {message || statusConfig.message}
        </Typography>

        {reference ? (
          <Typography sx={styles.reference}>
            Reference: {reference}
          </Typography>
        ) : null}

        <Box sx={styles.actionContainer}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              ...styles.closeCta,
              backgroundColor: statusConfig.buttonBackground,
              "&:hover": {
                backgroundColor: statusConfig.buttonBackground,
              },
            }}
          >
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentStatusModal;
